import { defineComponent as l, resolveComponent as p, createElementBlock as u, openBlock as d, normalizeClass as m, createVNode as n, createElementVNode as c } from "vue";
import { v as i } from "./vsIcon-Cyr63bPF.mjs";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const v = l({
  name: "vs-searchbar",
  components: {
    vsIcon: i
  },
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    return { emit: e, updateModelValue: (r) => {
      e("update:modelValue", r.target.value);
    } };
  }
}), b = {
  class: /* @__PURE__ */ m("text-2xl py-2 flex items-center font-bold text-md w-full text-primary border shadow-sm focus:shadow-primary rounded-md focus:outline-none box-border px-2 z-20 bg-surface")
}, V = ["value"];
function h(o, e, s, r, _, y) {
  const a = p("vs-icon");
  return d(), u("div", b, [
    n(a, {
      class: "opacity-50 mr-2",
      size: 28,
      name: "akar-icons:search"
    }),
    c("input", {
      class: "w-full outline-none bg-transparent border-b hover:border-black focus:border-primary",
      value: o.modelValue,
      placeholder: "Buscar",
      onInput: e[0] || (e[0] = (...t) => o.updateModelValue && o.updateModelValue(...t))
    }, null, 40, V),
    n(a, {
      name: "ci:close-small",
      color: "primary",
      "hover-color": "on-primary",
      animation: "pulse",
      width: "24",
      height: "24",
      class: "cursor-pointer",
      onClick: e[1] || (e[1] = (t) => o.emit("update:modelValue", ""))
    })
  ]);
}
const $ = /* @__PURE__ */ f(v, [["render", h]]);
export {
  $ as v
};
//# sourceMappingURL=vsSearchbar-BcFFAVue.mjs.map
